import create from "zustand";
import produce, { enableMapSet } from "immer";

enableMapSet();
// eslint-disable-next-line kf/const-naming-convention
const initStore = {
  navData: {},
  navOrder: {},
  favoriteItemsSet: new Set(),
  sectionMapping: {},
  currentNavItem: null,
  initLoad: false
};

const FAVORITE_ID = "Favorites";

const createWithImmer = (storeCreator) =>
  create((originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );

export const useNavStore = createWithImmer((setState, getState) => ({
  ...initStore,
  setData: ({ navData, navOrder }) => {
    setState((state) => {
      return {
        ...navData,
        navOrder,
        initLoad: true
      };
    });
    let item = getState().currentNavItem;
    if (!item) return;
    let section = getState().sectionMapping[item.Type] || item.Type;
    if (
      !navOrder[section].slice(0, 10).includes(item._id) &&
      !navOrder[FAVORITE_ID].includes(item._id)
    ) {
      let returnObject = {
        navOrder: {
          ...navOrder,
          [section]: [item._id, ...navOrder[section]]
        },
        [item._id]: item
      };
      setState((state) => {
        return returnObject;
      });
    }
  },
  setSectionMapping: (sectionMapping) => {
    setState(() => ({ sectionMapping }));
  },
  setActive: (item) => {
    setState((state) => ({ activeItem: item }));
  },
  addNewFavoriteFromExternal: (fav) => {
    if (!window.isLeftNavEnabled) return;
    let section = getState().sectionMapping[fav.Type] || fav.Type;
    setState((state) => {
      return {
        navOrder: {
          ...state.navOrder,
          Favorites: [fav._id, ...state.navOrder.Favorites],
          [section]: state.navOrder[section].filter((item) => item !== fav._id)
        },
        [fav._id]: fav
      };
    });
  },
  removeFavoriteFromExternal: (fav) => {
    if (!window.isLeftNavEnabled) return;
    let section = getState().sectionMapping[fav.Type] || fav.Type;
    setState((state) => {
      let returnobj = {
        navOrder: {
          ...state.navOrder,
          [section]: [fav._id, ...state.navOrder[section]],
          Favorites: state.navOrder[FAVORITE_ID].filter(
            (item) => item !== fav._id
          )
        },
        [fav._id]: fav
      };
      return { ...returnobj };
    });
  },
  setCurrentNavItem: (item) => {
    if (!window.isLeftNavEnabled) return;
    let { navOrder, initLoad } = getState();
    setState((state) => ({ currentNavItem: item }));
    if (!initLoad) return;
    let section = getState().sectionMapping[item.Type] || item.Type;
    if (
      !navOrder[section].slice(0, 10).includes(item._id) &&
      !navOrder[FAVORITE_ID].includes(item._id)
    ) {
      let returnObject = {
        navOrder: {
          ...navOrder,
          [section]: [
            item._id,
            ...navOrder[section].filter((id) => id !== item._id)
          ]
        },
        [item._id]: item
      };
      setState((state) => {
        return returnObject;
      });
    }
  },
  unArchiveItem(itemId, item) {
    if (!window.isLeftNavEnabled) return;
    let { navOrder } = getState();
    let section = getState().sectionMapping[item.Type] || item.Type;
    setState(() => ({
      navOrder: {
        ...navOrder,
        [section]: [
          ...navOrder[section].filter((id) => id !== item._id),
          item._id
        ]
      },
      [item._id]: item
    }));
  },
  createItem(item) {
    if (!window.isLeftNavEnabled) return;
    let section = getState().sectionMapping[item.Type] || item.Type;
    if (getState().navOrder[section].includes(item._id)) {
      return;
    }
    setState((state) => {
      let returnobj = {
        navOrder: {
          ...state["navOrder"],
          [section]: [item._id, ...state["navOrder"][section]]
        },
        [item._id]: item
      };
      return returnobj;
    });
  },

  updateItem: (item, newData) => {
    if (!window.isLeftNavEnabled) return;
    setState((state) => {
      let returnobj = {
        [item]: { ...state[item], ...newData }
      };
      return returnobj;
    });
  },

  deleteItem: (item, itemData) => {
    if (!window.isLeftNavEnabled) return;
    let navOrder = getState().navOrder;
    let section;
    if (navOrder.Favorites?.includes(item)) {
      section = FAVORITE_ID;
    } else {
      section =
        itemData.entityType ||
        getState().sectionMapping[itemData.Type] ||
        itemData.Type;
    }
    if (!navOrder[section]) return;
    setState((state) => ({
      navOrder: {
        ...state.navOrder,
        [section]: state.navOrder[section].filter((id) => id !== item)
      }
    }));
  }
}));
